import { render, staticRenderFns } from "./manage_driver.vue?vue&type=template&id=215ddb64"
import script from "./manage_driver.vue?vue&type=script&lang=js"
export * from "./manage_driver.vue?vue&type=script&lang=js"
import style0 from "./manage_driver.vue?vue&type=style&index=0&id=215ddb64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports